import { render, staticRenderFns } from "./impact.vue?vue&type=template&id=f6cc9c56"
import script from "./impact.vue?vue&type=script&lang=js"
export * from "./impact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports